<div class="grid-container text-white text-weight-600">
  <div class="card">
    <span class="text-size-16 text-res">TIPO DE PARADERO</span>
    <sit-icon
      class="icon"
      [icon]="Icon.bus_stop_type"
      alt="icono indicador paradero"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.tipo }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">NO. DE RUTAS</span>
    <sit-icon
      class="icon"
      [icon]="Icon.bus_route"
      alt="icono indicador bus"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.numRutas }}</span>
  </div>

  <div class="card">
    <span class="text-size-16 text-res">ADMINISTRADOR</span>
    <sit-icon
      class="icon"
      [icon]="Icon.admin"
      alt="icono persona"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.administra }}</span>
  </div>
</div>
